import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { map } from 'rxjs/operators';

@Injectable()
export class UserStampService {
    static parameters = [HttpClient];

    constructor(public http: HttpClient) {
    }

    InsertDocumentUserStampList(param): Observable<any[]> {
        return this.http.post('/api/SalesInvoices/InsertDocumentUserStampList', param).pipe(
            map((data: any[]) => data)
        )
    }

    DeleteUserstampByUser(param): Observable<any[]> {
        return this.http.post('/api/SalesInvoices/DeleteUserstampByUser', param).pipe(
            map((data: any[]) => data)
        )
    }

    ValidateDocumentUserStamp(param): Observable<any[]> {
        return this.http.post('/api/SalesInvoices/ValidateDocumentUserStamp', param).pipe(
            map((data: any[]) => data)
        )
    }
}